// The only way page code names a built file (spec 2026-10-10 §Ship 3, "asset references"). The
// build writes the tool's own address — "/name-tag/", unprefixed by any language — into every page
// it emits as window.__TOOL_ADDRESS__, so a page opened under /th/ or /ja/ still resolves a file
// beside its scripts (which are built once, at the tool's address), never beside the language copy
// of the page. There is no <base> element anywhere: three HTML references are absolute, and this
// helper is the page-code half of that contract.
//   path  the same literal page code uses today — "fonts/curated.json", "./assets/x-1A2B3C4D.ttf" —
//         or a path that came from data (a font record's file). A path that is already absolute
//         (starts with "/") is named as it is.
export function asset(path) {
  if (typeof path !== 'string' || path === '') throw new Error('asset(): a path is required');
  if (path.startsWith('/')) return path;
  const address = globalThis.__TOOL_ADDRESS__;
  if (typeof address !== 'string' || !address.startsWith('/') || !address.endsWith('/')) {
    throw new Error("asset(): this page's tool address is missing — the build must write window.__TOOL_ADDRESS__ = \"/<id>/\" into every page");
  }
  return `${address}${path.replace(/^(?:\.\/)?/, '')}`;
}
